const ColoredLine = () => {
  return (
    <div
      className="w-100 bg-sunrise-gradient"
      style={{
        height: '5px',
      }}
    ></div>
  );
};

export default ColoredLine;
